import React from 'react';
import { X } from 'lucide-react';

const BuiltBy = () => {
  const nots = ['No generic business frameworks', 'No consultant jargon'];

  return (
    <section id="built-by" className="py-24 md:py-32 px-6 max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <div className="order-2 lg:order-1">
          <div className="bg-ink text-cream rounded-3xl p-10 md:p-12 shadow-saas relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-lime/20 blur-[80px] rounded-full -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
            
            <div className="flex flex-col gap-4 mb-12 relative z-10">
              {nots.map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-4 bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm"
                >
                  <div className="w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center shrink-0">
                    <X className="w-4 h-4 text-red-400" strokeWidth={3} />
                  </div>
                  <span className="font-semibold text-lg text-cream/90">{item}</span>
                </div>
              ))}
            </div>
            
            <p className="text-3xl md:text-4xl font-bold leading-tight tracking-tight relative z-10">
              Just practical governance tools built by{' '}
              <span className="text-lime">governance professionals.</span>
            </p>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 text-ink leading-tight">
            Built by governance{' '}
            <span className="highlighter mt-2 block">professionals.</span>
          </h2>
          <p className="text-lg md:text-xl text-ink/60 mb-6 leading-relaxed font-medium">
            GovernWell was created by governance practitioners who work with boards every
            day.
          </p>
          <p className="text-lg md:text-xl text-ink/60 leading-relaxed font-medium">
            The system combines governance reviews, board effectiveness assessments,
            maturity scoring, gap analysis, and improvement planning into one structured
            governance improvement process.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BuiltBy;
